import Vue from "vue";
// @ts-ignore
import VueVirtualScroller from "vue-virtual-scroller";

Vue.use(VueVirtualScroller);
